import { useSetAtom } from "jotai";
import { useState } from "react";
import { orderAtom } from "../atoms/atoms";
import { Form } from "react-bootstrap";

const CompanyForm = () => {
    const [companyName, setCompanyName] = useState("");
    const [nip, setNip] = useState("");

    const setOrder = useSetAtom(orderAtom);

    const onCompanynameChange = (e) => {
        setCompanyName(e.target.value);
        setOrder((prev) => ({
            ...prev,
            companyName: e.target.value,
        }));
    }

    const onNipChange = (e) => {
        setNip(e.target.value);
        setOrder((prev) => ({
            ...prev,
            companyNip: e.target.value,
        }));
    }

    return (

        <div className="row">
            <div className="col-12 col-md-6">


                <Form.Group className="mb-3" controlId="formCompanyName">
                    <Form.Label>Nazwa Firmy:</Form.Label>
                    <Form.Control
                        onChange={(e) => onCompanynameChange(e)}
                        value={companyName}
                        maxLength="200"
                        type="text"
                        placeholder="Nazwa Firmy"
                        autoComplete="" />
                </Form.Group>
            </div>
            <div className="col-12 col-md-6">

                <Form.Group className="mb-3" controlId="formCompanyNip">
                    <Form.Label>NIP:</Form.Label>
                    <Form.Control
                        onChange={(e) => onNipChange(e)}
                        value={nip}
                        maxLength="200"
                        type="text"
                        placeholder="NIP"
                        autoComplete="" />
                </Form.Group>
            </div>
        </div>


    )
}

export default CompanyForm;